export enum userType {
  ADMIN = 'admin',
  SDR = 'sdr',
  AGENT = 'agent',
}
